import script from "./ActionLog.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionLog.vue?vue&type=script&setup=true&lang=js"

import "./ActionLog.vue?vue&type=style&index=0&id=b96c2e5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b96c2e5a"]])

export default __exports__